import type {ManagedProject} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useManagedProjects() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'managedProjectsGlobal',
      depth: 4,
      draft: !!route.query.preview,
    })

    return result as Populated<ManagedProject>
  }

  return {fetch}
}
